import { gql } from '@apollo/client'
import { userFragment } from '../fragments/user'
import { paginationDetailsFragment } from '../fragments/pagination-details'
import { betSlipFragment } from '../fragments/bet-slip'

export const initialLoad = gql`
  query InitialLoad($id: ID!, $userId: String!) {
    user: getUserById(id: $id) {
      ...User
    }
    getBetHistory: getBetHistoryByUserId(
      userId: $userId
      take: 5
      page: 1
    ) {
      betSlips {
        ...BetSlip
      }
      metaData {
        ...PaginationDetails
      }
    }
    pendingBets: getBetHistoryByUserId(
      userId: $userId
      resolutionType: pending
      take: 20
      page: 1
    ) {
      betSlips {
        ...BetSlip
      }
    }
  }
  ${userFragment}
  ${betSlipFragment}
  ${paginationDetailsFragment}
`
